import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Document20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.75 18.5C17.75 19.1904 17.1904 19.75 16.5 19.75H3.5C2.80964 19.75 2.25 19.1904 2.25 18.5V1.5C2.25 0.809645 2.80964 0.25 3.5 0.25H11.7929C12.1244 0.25 12.4424 0.381696 12.6768 0.616117L17.3839 5.32322C17.6183 5.55764 17.75 5.87559 17.75 6.20711V18.5ZM3.75 18.25V1.75H10.25V7C10.25 7.41421 10.5858 7.75 11 7.75H16.25V18.25H3.75ZM16.1893 6.25H11.75V1.81066L16.1893 6.25Z'
      fill='currentColor'
    />
  </Svg>
);

Document20.displayName = 'Document20';
export default Document20;
